var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcTiktok(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 45,
    viewBox: "0 0 39 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M27.4 0.23999H21.03L20.96 31.29C20.96 35.1 17.6 38.1 13.79 38.1C9.98004 38.1 6.89005 35.01 6.89005 31.2C6.89005 27.39 9.98004 24.3 13.79 24.3C14.08 24.3 14.35 24.35 14.63 24.38V17.72C14.35 17.7 14.08 17.68 13.79 17.68C6.33004 17.68 0.280029 23.73 0.280029 31.19C0.280029 38.65 6.33004 44.7 13.79 44.7C21.25 44.7 27.3 38.65 27.3 31.19V12.91C29.49 16.26 33.23 18.28 37.23 18.28C37.6 18.28 37.96 18.26 38.32 18.22H38.33V10.82C32.61 10.41 28 5.94999 27.4 0.23999Z",
    fill: "#FED5AB"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTiktok);
export default __webpack_public_path__ + "static/media/ic_tiktok.725d5b1dd708891e1702d5c646a55567.svg";
export { ForwardRef as ReactComponent };